/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import apiClient from '../api/client';

export const accountService = {
  getAccounts: (params) => apiClient.get('/accounts', { params }),
  getAccountById: (id) => apiClient.get(`/accounts/${id}`),
  createAccount: (data) => apiClient.post('/accounts', data),
  updateAccount: (id, data) => apiClient.patch(`/accounts/${id}`, data),
  deleteAccount: (id) => apiClient.delete(`/accounts/${id}`),
  // Pixo user-sync webhook credentials (secrets are write-only; the URL is derived from the slug)
  getPixoWebhook: (id) => apiClient.get(`/accounts/${id}/integrations/pixo/webhook`),
  savePixoWebhook: (id, data) => apiClient.put(`/accounts/${id}/integrations/pixo/webhook`, data),
  disablePixoWebhook: (id) => apiClient.delete(`/accounts/${id}/integrations/pixo/webhook`)
};
